import { Component } from 'js-component-framework';
import Siema from 'siema';
import './gallery.scss';

/**
 * Component for image gallery
 */

export default class Gallery extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();

    this.setUpButtons = this.setUpButtons.bind(this);
    this.siema = null;
    this.closeClick = this.closeClick.bind(this);
    this.galleryShowing = false;
    this.nextBtn = null;
    this.prevBtn = null;
  }

  /**
   * Creates control buttons and listeners
   */
  setUpButtons() {
    const {
      element,
      siema,
    } = this;

    // Append buttons for switching images
    this.prevBtn = this.createButton('prev');
    element.appendChild(this.prevBtn);
    this.nextBtn = this.createButton('next');
    element.appendChild(this.nextBtn);
    // init button display
    this.toggleButtons();

    this.prevBtn.addEventListener('click', () => {
      siema.prev();
      this.toggleButtons();
    });
    this.nextBtn.addEventListener('click', () => {
      siema.next();
      this.toggleButtons();
    });

    // Append close button
    element.appendChild(this.createButton('close'));
    document.querySelector('.close')
      .addEventListener('click', this.closeClick);
  }

  closeClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.classList.remove('open');
    this.galleryShowing = false;
    window.removeEventListener('resize', this.setUpButtons);
    this.siema.destroy(true);
  }

  /**
   * Creates a new button with specified class
   */
  createButton(buttonType) { // eslint-disable-line class-methods-use-this
    const elem = document.createElement('button');
    elem.classList.add(buttonType);
    return elem;
  }

  /**
   * Shows and hides buttons to control gallery
   */
  toggleButtons() {
    const {
      nextBtn,
      prevBtn,
      siema,
    } = this;
    const {
      images,
    } = this.children;
    if (0 === siema.currentSlide) {
      prevBtn.classList.add('hide');
    } else if (images.length - 1 === siema.currentSlide) {
      nextBtn.classList.add('hide');
    } else {
      prevBtn.classList.remove('hide');
      nextBtn.classList.remove('hide');
    }
  }

  init() {
    const {
      element,
    } = this;

    if (! element) {
      return;
    }

    const {
      images,
    } = this.children;

    element.addEventListener('click', (ev) => {
      // If the gallery isn't showing, open it
      if (! this.galleryShowing) {
        // Get the index of the image that was clicked
        const startImageIndex = Array.from(images)
          .findIndex((img) => img === ev.target);
        // Create the gallery
        this.siema = new Siema({
          selector: element,
          duration: 300,
          easing: 'ease-out',
          perPage: 1,
          startIndex: startImageIndex,
          draggable: true,
          multipleDrag: false,
          loop: true,
          rtl: false,
        });
        // Set the gallery to open
        this.galleryShowing = true;
        element.classList.add('open');

        // Create control buttons
        this.setUpButtons();

        // Add window resize listener
        window.addEventListener('resize', this.setUpButtons);
      }
    });
  }
}
